import { useEffect, useState } from "react";
import { clientCMSbanner } from "../../sanity/clientCMSbanner.js";
import Carousel from "react-bootstrap/Carousel";
import Container from "react-bootstrap/Container";
import "./HeroSection.css";

export default function HeroSection() {
  const [allBannersData, setAllBannersData] = useState(null);
  const [backupBanner, setBackupBanner] = useState(
    <div className="hero-section-loading">
      <div className="half-circle">
        <div className="inner-star"></div>
        <div className="star"></div>
      </div>
    </div>,
  );

  useEffect(() => {
    clientCMSbanner
      .fetch(
        `*[_type == "banner"] | order(publishedAt desc) {
        title,
        mainImage{
            asset->{
            _id,
            url
            },
        },
        mobileImage{
            asset->{
            _id,
            url
            },
        },
        wideImage{
            asset->{
            _id,
            url
            },
        },
        link,
        external,
        publishedAt
    }`,
      )
      .then((data) => setAllBannersData(data))
      .catch((error) => {
        console.error("An error occurred:", error.message);
        if (!allBannersData)
          setBackupBanner(
            <div className="hero-section-item">
              <div className="hero-section-img-backup" />
              <div className="hero-section-img-mobile-backup" />
            </div>,
          );
        else setBackupBanner(<div className="hero-section-loading" />);
      });
  }, []);

  return (
    <Container fluid className="hero-section">
      <Carousel
        controls={true}
        indicators={true}
        fade
        interval={12000}
        touch={true}
        pause={false}
        className="hero-section-carousel"
      >
        {allBannersData && allBannersData.length > 0
          ? allBannersData &&
            allBannersData.map((banner, index) => (
              <Carousel.Item key={index} className="hero-section-item">
                <a
                  href={banner.link}
                  rel="noopener noreferrer"
                  target={banner.external ? "_blank" : "_self"}
                >
                  <img
                    src={banner.mainImage.asset.url}
                    className="hero-section-img"
                    alt="Banner Grupo Krause"
                    fetchpriority="high"
                  />
                  <img
                    src={banner.mobileImage.asset.url}
                    className="hero-section-img-mobile"
                    alt="Banner Grupo Krause"
                    fetchpriority="high"
                  />
                  <img
                    src={banner.wideImage.asset.url}
                    className="hero-section-img-wide"
                    alt="Banner Grupo Krause"
                    fetchpriority="high"
                  />
                </a>
              </Carousel.Item>
            ))
          : backupBanner}
      </Carousel>
    </Container>
  );
}
